import { Button } from '#/components/Button/Button';
import { useI18n } from '#/i18n/hooks/useI18n';
import type { I18nLocale } from '#/i18n/types/I18nLocale';
import type { CmsApiPagePost } from '#/modules/cms/api/types/CmsApiPage';
import { getContentUrlByLocale } from '#/modules/cms/helpers/getContentUrlByLocale';
import { showModal } from '#/zustand-stores/modalStore';

export function ShareButton({ content }: { content: CmsApiPagePost }) {
  const { i18n } = useI18n();

  const shareUrl = getContentUrlByLocale({ content }) as Record<
    I18nLocale,
    string
  >;
  const handleShare = () => {
    showModal('SHARE_LISTING', {
      listingType: 'URL',
      messageOverride: i18n('Check out this article'),
      shareUrl,
    });
  };
  return (
    <Button
      type="button"
      onClick={handleShare}
      qaId="social-share-button"
      variant="secondary"
      icon={{ type: 'normalized', name: 'share' }}
    >
      {i18n('Share')}
    </Button>
  );
}
